function parseEnv() {
  const env = process.env;
  // Production (Cloudflare Worker): the API is proxied on the UI's own origin (worker/index.js), so
  // every client's build is the same. REACT_APP_API_BASE_URL still wins when set (Windows package).
  const fallback = env.NODE_ENV === "production" ? window.location.origin : "http://localhost:3020";
  const apiBase = env.REACT_APP_API_BASE_URL || fallback;
  env.API_BASE_URL = apiBase;
  env.ORIGINAL_API_BASE_URL = apiBase;
  return env;
}

export const InitialState = {
  config: { env: parseEnv() },
  session: { isValidSession: false },
  tradeData: {},
  pageState: {
    selectedPage: "Dashboard",
    isLoading: false,
    pageError: null,
    showAlert: false,
    alertMessage: "",
    alertType: "info",
  },
  theme: { mode: "PT", isVirtual: true },
  jobFeedLog: "",
};
